import { gql } from "@apollo/client";
import { SHORTCUT_KEY_CODE_VIDEO_NEXT_HIGHLIGHT, SHORTCUT_KEY_CODE_VIDEO_PREVIOUS_HIGHLIGHT } from "helpers/SHORTCUTS";
import useDOMEvent from "helpers/useDOMEvent";
import { videoPageContext } from "pages/VideoPage";
import { useContext } from "react";

export const VideoEventNavShortcutHandlerFragment = gql`
  fragment VideoEventNavShortcutHandlerFragment on Game {
    id
    events {
      id
      startAtSeconds
      occurredAtSeconds
    }
  }
`;

export default function VideoEventNavShortcutHandler({ game }) {
  const { isVideoPageModalActive, activeEventId, currentTime, selectEvent, filteredEventIds } =
    useContext(videoPageContext);

  // events come ordered by occurred time, same as the list
  const events = game?.events.filter((event) => filteredEventIds.includes(event.id)) || [];
  const activeIndex = events.findIndex((event) => event.id === activeEventId);

  // step through the list rather than by start time, which can be negative or overlap a neighbour
  const previousEvent =
    activeIndex >= 0 ? events[activeIndex - 1] : events.findLast((event) => event.occurredAtSeconds <= currentTime);
  const nextEvent =
    activeIndex >= 0 ? events[activeIndex + 1] : events.find((event) => event.occurredAtSeconds > currentTime);

  useDOMEvent("keydown", (evt) => {
    if (!isVideoPageModalActive) return;
    if (evt.metaKey || evt.ctrlKey || evt.altKey || evt.shiftKey) return;
    if (evt.code === SHORTCUT_KEY_CODE_VIDEO_PREVIOUS_HIGHLIGHT) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      if (previousEvent) selectEvent(previousEvent);
    }
    if (evt.code === SHORTCUT_KEY_CODE_VIDEO_NEXT_HIGHLIGHT) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      if (nextEvent) selectEvent(nextEvent);
    }
  });
  return null;
}
